var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H29C32.3137 0 35 2.68629 35 6V18C35 21.3137 32.3137 24 29 24H6C2.68629 24 0 21.3137 0 18V6Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15723_4764)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_15723_4764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8976 11.7214V14.8946H15.874V7.04688H18.5354C19.1837 7.04688 19.7979 7.28572 20.2756 7.72929C20.7533 8.13874 20.9921 8.75291 20.9921 9.40121C20.9921 10.0495 20.7533 10.6296 20.2756 11.0731C19.7979 11.5167 19.2179 11.7555 18.5354 11.7555L16.8976 11.7214ZM16.8976 8.00226V10.7319H18.6037C18.979 10.7319 19.3543 10.5954 19.5932 10.3225C20.1391 9.81065 20.1391 8.95764 19.6273 8.44583L19.5932 8.4117C19.3202 8.13874 18.979 7.96813 18.6037 8.00226H16.8976Z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3464 9.36719C24.0971 9.36719 24.6771 9.57191 25.1207 9.98136C25.5642 10.3908 25.769 10.9367 25.769 11.6192V14.8947H24.8136V14.1441H24.7795C24.37 14.7583 23.79 15.0654 23.1076 15.0654C22.5275 15.0654 22.0157 14.8947 21.6062 14.5535C21.2309 14.2123 20.9921 13.7346 20.9921 13.2228C20.9921 12.6769 21.1968 12.2333 21.6062 11.8921C22.0157 11.5509 22.5957 11.4144 23.2782 11.4144C23.8923 11.4144 24.37 11.5168 24.7453 11.7556V11.5168C24.7453 11.1756 24.6089 10.8344 24.3359 10.6297C24.0629 10.3908 23.7217 10.2543 23.3464 10.2543C22.7663 10.2543 22.3228 10.4932 22.0157 10.9709L21.1285 10.4249C21.6745 9.70839 22.391 9.36719 23.3464 9.36719ZM22.0498 13.257C22.0498 13.5299 22.1863 13.7688 22.391 13.9052C22.6299 14.0758 22.9028 14.1782 23.1758 14.1782C23.5852 14.1782 23.9947 14.0076 24.3018 13.7005C24.643 13.3934 24.8136 13.0181 24.8136 12.6087C24.5065 12.3698 24.0629 12.2333 23.4829 12.2333C23.0734 12.2333 22.7322 12.3357 22.4593 12.5404C22.1863 12.711 22.0498 12.9499 22.0498 13.257Z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2967 9.53906L27.9187 17.2845H26.8951L28.1575 14.5889L25.9397 9.57318H27.0316L28.6352 13.4288H28.6694L30.2389 9.57318H31.2967V9.53906Z",
    fill: "#5F6368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8372 11.0384C12.8372 10.7314 12.8031 10.4243 12.769 10.1172H8.50391V11.8573H10.9265C10.8241 12.4033 10.517 12.9151 10.0393 13.2222V14.3482H11.5065C12.3595 13.5634 12.8372 12.4033 12.8372 11.0384Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50391 15.44C9.73225 15.44 10.7559 15.0305 11.5065 14.3481L10.0393 13.2221C9.62989 13.4951 9.11808 13.6657 8.50391 13.6657C7.3438 13.6657 6.32018 12.8809 5.97897 11.7891H4.47766V12.9492C5.26244 14.4846 6.79787 15.44 8.50391 15.44Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.97911 11.7909C5.77439 11.245 5.77439 10.6308 5.97911 10.0507V8.89062H4.4778C3.8295 10.1531 3.8295 11.6544 4.4778 12.951L5.97911 11.7909Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50397 8.2058C9.15226 8.2058 9.76643 8.44465 10.2441 8.88822L11.5407 7.59163C10.7218 6.84097 9.62995 6.3974 8.53809 6.43152C6.83205 6.43152 5.2625 7.3869 4.51184 8.92234L6.01315 10.0824C6.32024 8.99058 7.34386 8.2058 8.50397 8.2058Z",
    fill: "#EA4335"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15723_4764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_15723_4764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.2966,
    height: 13,
    fill: "white",
    transform: "translate(4 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePay);
export default __webpack_public_path__ + "static/media/google-pay.f495540b.svg";
export { ForwardRef as ReactComponent };